import { render } from "./ClaimEvidenceFile.vue?vue&type=template&id=c72c839e"
import script from "./ClaimEvidenceFile.vue?vue&type=script&lang=js"
export * from "./ClaimEvidenceFile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__